// extracted by mini-css-extract-plugin
module.exports = {"divider":"Divider_divider__E_B95","dashed":"Divider_dashed__32bVx"};